export const googleCoordinates = (position) => ({
    lat: position.latitude,
    lng: position.longitude,
});
